import { render, staticRenderFns } from "./TopHead.vue?vue&type=template&id=2b74c80b&scoped=true&"
import script from "./TopHead.vue?vue&type=script&lang=js&"
export * from "./TopHead.vue?vue&type=script&lang=js&"
import style0 from "./TopHead.vue?vue&type=style&index=0&id=2b74c80b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b74c80b",
  null
  
)

export default component.exports